import request from '@/utils/request'

/**
 * 获取横幅图片列表
 */
function getBannerList() {
  return request({
    url: '/banner/getBannerList',
    method: 'get'
  })
}

/**
 * 新增
 */
function createBanner(data) {
  return request({
    url: '/banner/create',
    method: 'post',
    data
  })
}

/**
 * 编辑
 */
function updateBanner(data) {
  return request({
    url: '/banner/update',
    method: 'put',
    data
  })
}

/**
 * 删除
 */
function deleteBanner(data) {
  return request({
    url: '/banner/delete',
    method: 'DELETE',
    data
  })
}

export {
    getBannerList,
    createBanner,
    updateBanner,
    deleteBanner
}
